import { Dispatch, SetStateAction } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { FilterIcon } from '@/assets/icons/filter';
import { CloseInfoIcon } from '@/assets/icons/info-icons/closeInfo';
import { themeVar } from '@/styles/theme';
import { useResponsive } from '../../../hooks/use-responsive';
import { AdditionalFilters } from './types';
import { addSpaceBtwCamelCases, createNewFilter } from './utils';

interface ChosenFiltersProps extends AdditionalFilters {
  setChosenFilters: Dispatch<SetStateAction<boolean>>;
}

const ChosenFilters = ({ filters, filtersItems, applyFilters, setChosenFilters }: ChosenFiltersProps) => {
  const { isMobile, isTablet } = useResponsive();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const removeFilter = (indexElement: number) => {
    const newFilters = filters.filter((_, index) => index !== indexElement);
    applyFilters(newFilters);
    newFilters.find((type) => {
      let filterField = queryParams.get('filterField');
      type.typeFilter !== 'nextTask' ? (filterField = '') : null;

      let filterInvestmentsField = queryParams.get('filterInvestmentsField');
      type.typeFilter !== 'investments' ? (filterInvestmentsField = '') : null;
    });
    if (filters.length === 1) clearAll();
  };

  const clearAll = () => {
    applyFilters([createNewFilter('Select A Filter Option')]);
    setChosenFilters(false);

    let filterBy = queryParams.get('filterBy');
    filterBy = '';
    let filterField = queryParams.get('filterField');
    filterField = '';
  };

  const getChosenFilterLabel = (typeFilter: string, value: string) => {
    return filtersItems?.[typeFilter]?.find((item) => item.value === value)?.label;
  };

  return (
    <Container id="chosenFliters">
      <Divider />
      <Filters>
        {filters.map(({ id, typeFilter, selected }, index) => (
          <FilterItem isMobile={isMobile} isTablet={isTablet} key={id} border={false}>
            <FilterIcon />
            <FilterText isMobile={isMobile} isTablet={isTablet}>
              {addSpaceBtwCamelCases(typeFilter)}: {getChosenFilterLabel(typeFilter, selected)}
            </FilterText>
            <CloseFilter onClick={() => removeFilter(index)}>
              <CloseInfoIcon fill={themeVar('font.action')} width={isMobile || isTablet ? '22' : '15'} height={isMobile || isTablet ? '21' : '14'} />
            </CloseFilter>
          </FilterItem>
        ))}
        <FilterItem isMobile={isMobile} isTablet={isTablet} border={true}>
          <ClearAll isMobile={isMobile} isTablet={isTablet}>
            Clear All
          </ClearAll>
          <CloseFilter onClick={clearAll}>
            <CloseInfoIcon fill={themeVar('font.action')} width={isMobile || isTablet ? '22' : '15'} height={isMobile || isTablet ? '21' : '14'} />
          </CloseFilter>
        </FilterItem>
      </Filters>
    </Container>
  );
};

export default ChosenFilters;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Divider = styled.div`
  background: ${themeVar('border.base')};
  height: 1px;
  width: 100%;
  margin: 10px 0;
`;

const Filters = styled.div`
  gap: 5px;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 20px;
`;

const FilterItem = styled.div<{ border: boolean; isMobile: boolean; isTablet: boolean }>`
  display: flex;
  justify-content: space-between;
  background: ${themeVar('layer.2')};
  border: ${({ border }) => (border ? `1px solid ${themeVar('font.action')}` : 'none')};
  border-radius: 4px;
  column-gap: 6px;
  padding: ${({ isMobile, isTablet }) => (isMobile || isTablet ? '4px 7px' : '3px 6px')};
  align-items: center;
`;

const FilterText = styled.span<{ isMobile: boolean; isTablet: boolean }>`
  font-family: 'Blinker';
  font-weight: 400;
  font-size: ${({ isMobile, isTablet }) => (isMobile || isTablet ? '14px' : '13px')};
  line-height: 18px;
  color: ${themeVar('font.weak')};
  text-transform: capitalize;
`;

const ClearAll = styled.span<{ isMobile: boolean; isTablet: boolean }>`
  font-weight: 600;
  font-size: ${({ isMobile, isTablet }) => (isMobile || isTablet ? '14px' : '13px')};
  line-height: 18px;
  color: ${themeVar('font.action')};
`;

const CloseFilter = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  transform: scale(0.6);
`;
